import * as m from '@/paraglide/messages';
import IconContactSalesSvg from '@listening/assets/astro/icons/icon-contact-sales.svg';
import IconHelpCenterSvg from '@listening/assets/astro/icons/icon-help-center.svg';
import IconSupportSvg from '@listening/assets/astro/icons/icon-support.svg';

import { SupportOptionsCard } from '@/components/astro/new-design/cards/support-options-card';

export function HeroHeadingContactUs() {
  return (
    <section className='flex flex-col items-center justify-center px-5 py-8 sm:p-14 lg:p-18'>
      <div className='flex max-w-[1296px] flex-col items-center gap-12 sm:gap-18'>
        <div className='flex items-center gap-18'>
          <div className='inline-flex flex-col items-center justify-start gap-4'>
            <h1 className='self-stretch text-center text-[48px] leading-[52px] font-bold text-navy-820 md:text-[68px] md:leading-[73px]'>
              {m.common_contact_us()}
            </h1>
            <p className='text-center text-xl leading-[30px] font-medium text-slate-700'>
              {m.contact_hero_subtitle()}
            </p>
          </div>
        </div>
        <div className='grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3'>
          <SupportOptionsCard
            href='https://www.listening.com/edu'
            image={IconContactSalesSvg}
            imageAlt='Contact sales Listening.com'
            text={m.contact_card_sales_text()}
            title={m.contact_card_sales_title()}
          />
          <SupportOptionsCard
            href='https://help.listening.com/'
            image={IconHelpCenterSvg}
            imageAlt='Help center Listening.com'
            text={m.contact_card_help_text()}
            title={m.contact_card_help_title()}
          />
          <SupportOptionsCard
            href='https://help.listening.com/'
            image={IconSupportSvg}
            imageAlt='Contact support Listening.com'
            text={m.contact_card_support_text()}
            title={m.contact_card_support_title()}
          />
        </div>
      </div>
    </section>
  );
}
